export default __webpack_public_path__ + "8e766f918bc4ebd5922ec3b1e41b7b97.svg";